import { useNavigate } from "react-router-dom";
import BottomNav from "./BottomNav";
import SafeAvatar from "./SafeAvatar";
import { useAuth } from "@/lib/AuthContext";

export default function AppShell({ children, role, title, right, headerless }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const profilePath = role === "pro" ? "/pro/profile" : "/p/profile";
  return (
    <div className="app-shell grain-bg pb-24">
      {!headerless && (
        <header className="sticky top-0 z-40 bg-sand/85 backdrop-blur-md border-b border-border px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <img src="/brand/icon-192.png" alt="Besoin d'un Pro" className="h-9 w-9 rounded-2xl shadow-sm" />
            <div className="min-w-0">
              <div className="text-[11px] uppercase tracking-widest text-slate2">Besoin d&apos;un Pro&nbsp;?</div>
              <h1 className="text-base font-heading font-bold text-ink leading-tight truncate">{title}</h1>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {right}
            {user && (
              <button
                onClick={() => nav(profilePath)}
                className="tap-scale"
                aria-label="Mon profil"
                data-testid="header-profile-btn"
              >
                <SafeAvatar
                  src={user.avatar}
                  role={user.role}
                  name={user.name}
                  className="h-9 w-9 rounded-full object-cover border-2 border-white shadow-sm ring-2 ring-transparent hover:ring-brand transition-all"
                />
              </button>
            )}
          </div>
        </header>
      )}
      <main className="px-5 py-4 animate-fade-up">
        {children}
      </main>
      <BottomNav role={role} />
    </div>
  );
}
